const LoadingSpinner = () => (
  <div className="loading-spinner-container" data-testid="loading-spinner">
    <div className="loading-spinner"></div>
  </div>
);

export default LoadingSpinner;
